import { usePastShiftsByParticipantId } from '../../../../ui/features/shift/hooks/usePastShiftsByParticipantId';
export const useParticipantPastShiftsTableDataProvider = (request, additionalData) => {
    var _a, _b;
    const { participantId, missionId } = additionalData;
    const { shifts, fetchShifts, total: totalShifts, ids, isLoading, error, } = usePastShiftsByParticipantId({
        participantId,
        missionId,
        offset: (_a = request === null || request === void 0 ? void 0 : request.offset) !== null && _a !== void 0 ? _a : 0,
        limit: (_b = request === null || request === void 0 ? void 0 : request.limit) !== null && _b !== void 0 ? _b : 0,
    });
    const data = {
        filteredRowCount: totalShifts,
        rows: shifts !== null && shifts !== void 0 ? shifts : [],
    };
    return {
        data,
        error,
        isLoading,
        reload: fetchShifts,
        customBackendResponseData: {
            ids,
            mutate: fetchShifts,
        },
    };
};
